//@prepros-prepend libs/*.js

$(document).ready(function () {

    $(document).on('click', '.toggle-mnu', function () {
        if ($(this).hasClass('on')) {
            $(this).removeClass('on')
            $('.nav-mob').removeClass('open')
            setTimeout(function () {
                $('.nav-overlay').removeClass('open')
                $('body').removeClass('nav-menu-open')
            }, 250)
        }
        else {
            $(this).addClass('on')
            $('.nav-overlay').addClass('open')
            setTimeout(function () {
                $('.nav-mob').addClass('open')
                $('body').addClass('nav-menu-open')
            }, 250)
        }

        return false
    })

    $(document).on('click', '.nav-overlay', function () {
        $('.toggle-mnu').removeClass('on')
        $('.nav-mob').removeClass('open')
        setTimeout(function () {
            $('.nav-overlay').removeClass('open')
            $('body').removeClass('nav-menu-open')
        }, 250)
        return false
    })

    $('input[type=number]').number()

    var key_pressed = false
    var number_keypress_timer = null
    $('input[type=number]').on('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight'].indexOf(e.key) >= 0) {
            return true
        }
        var $input = $(this)
        key_pressed = true
        clearTimeout(number_keypress_timer)
        number_keypress_timer = setTimeout(function () {
            if (key_pressed) {
                $input.trigger('change')
            }
        }, 1000)
    })

    $('input[type=number]').on('change', function () {
        key_pressed = false
        var $this = $(this),
            min = parseInt($this.attr('min')),
            number = parseInt($this.val())
        if (number < min) {
            number = min;
        }
        if (number > 9999) {
            number = 9999
        }
        this.value = number

        if (min) {
            if (number == min) {
                $(this).parent().find('.fs-number-down').hide()
                $(this).parents('.shopcart-count').find('.btn-delete').show()
            }
            else {
                $(this).parent().find('.fs-number-down').show()
                $(this).parents('.shopcart-count').find('.btn-delete').hide()
            }
        }
        else {
            $(this).parent().find('.fs-number-down').show()
        }
    })

    $('input[type=number]').on('focus', function () {
        if (parseInt(this.value) === 0) {
            this.value = ''
        }
    })

    // добавлено конец

    $(window).load(function () {
        window.is_number_init = false
        $('input[type=number]').trigger('change')
        window.is_number_init = true
    })

    $('.btn-delete').on('click', function () {
        $(this).parents('.shopcart__item').fadeOut(500)
    })

    $('.shopcart__promo-trigger').on('click', function (event) {
        event.preventDefault()
        $('.form-promo-wrap').slideToggle('fast')
    })

    $('.wrap .tab').click(function () {
        $('.wrap .tab').removeClass('active').eq($(this).index()).addClass('active')
        $('.tab__item').hide().eq($(this).index()).fadeIn()
    })

    $(document).on('keyup', '.form-promo__input', function () {
        var promo = $(this).val()
        if (promo.length == 0) {
            $('.btn-js').prop('disabled', true).removeClass('active')
        }
        else {
            $('.btn-js').prop('disabled', false).addClass('active')
        }
    })

    $(document).on('change', '.shopcart-form__total input', function () {
        if ($(this).is(':checked')) {
            $('.shopcart-form__total .btn').prop('disabled', false).addClass('active')
        }
        else {
            $('.shopcart-form__total .btn').prop('disabled', true).removeClass('active')
        }
    })

    // $(document).on('change', '#pickup', function() {
    //   if ($(this).is(':checked')) {
    //     $('.shopcart-form__pickup').slideDown().prev().slideUp();
    //     $('.shopcart-form__address').slideUp();
    //   }
    // });
    //
    // $(document).on('change', "input[name='delivery']:not('#pickup')", function() {
    //   if ($(this).is(':checked') && $('.shopcart-form__pickup').is(':visible')) {
    //     $('.shopcart-form__pickup').slideUp().prev().slideDown();
    //     $('.shopcart-form__address').slideDown();
    //   }
    // });

    $(document).on('input', '.shopcart-form__recovery input, .shopcart-form__signup input', function () {
        var form = $(this).parents('form')
        var btn = form.find('.btn')
        var btn_active = true
        form.find('.shopcart-form__input').each(function () {
            var $this = $(this)
            btn_active = btn_active && (!$this.prop('required') || $this.val().length > 0 || $this.is(':-webkit-autofill'))
        })
        form.find('.shopcart-form__checkbox').each(function () {
            var $this = $(this)
            window.console.log($this.prop('required'), $this.val())
            btn_active = btn_active && (!$this.prop('required') || $this.prop('checked'))
        })
        if (btn_active) {
            btn.prop('disabled', false).addClass('active')
        }
        else {
            btn.prop('disabled', true).removeClass('active')
        }
    })

    $(document).on('click', '#signup-terms_accepted', function () {
        $('#signup-terms_accepted-error').hide()
    });

    var $auth_form = $('.js-auth-form')
    if ($auth_form.length) {
        setTimeout(function () {
            $auth_form.find('.shopcart-form__input').trigger('input')
        }, 100)
    }

    $('.shopcart-another__forget').on('click', function (event) {
        event.preventDefault()
        $(this).text($('.shopcart-form__recovery').is(':visible') ? 'Я забыл пароль' : 'Войти в учетную запись')
        $('.tabs .tab:last-child').text($('.shopcart-form__recovery').is(':visible') ? 'Войти в учетную запись' : 'Восстановление пароля')
        $('.shopcart-form__enter').slideToggle('fast')
        $('.shopcart-form__recovery').slideToggle('fast')
        $('.shopcart-social').slideToggle('fast')
    })

    $('.shopcart-form').validate({
        rules: {
            email: {
                required: true,
                email: true,
            },
            name: {
                required: true,
                minlength: 2,
            },
            phone: {
                required: true,
            },
        },
        messages: {
            email: {
                required: 'Обязательно для заполнения',
                email: 'Введите E-mail адрес',
            },
            name: {
                required: 'Обязательно для заполнения',
                minlength: 'Минимум 2 знака',
            },
            phone: {
                required: 'Обязательно для заполнения',
            },
        },
        focusCleanup: true,
        focusInvalid: false,
    })

    $('.shopcart-form__enter').validate({
        rules: {
            login: {
                required: true,
                email: true,
            },
            password: {
                required: true,
                //minlength: 6,
            },
        },
        focusCleanup: true,
        focusInvalid: false,
    })

    $('.shopcart-form__recovery').validate({
        rules: {
            email: {
                required: true,
                email: true,
            },
        },
        focusCleanup: true,
        focusInvalid: false,
        // submitHandler: function(form) {
        //   $.ajax({
        //     type: "POST",
        //     url: "mail.php", //Change
        //     data: $(form).serialize()
        //   }).done(function() {
        //     setTimeout(function() {
        //       $(form).slideUp('fast');
        //       $('.message').slideDown('fast');
        //     }, 1000);
        //
        //   });
        //   return false;
        // }
    })
    $('.shopcart-form__signup').validate({
        rules: {
            'data[firstname]': {
                required: true,
            },
            'data[lastname]': {
                required: true,
            },
            'data[phone]': {
                required: true,
            },
            'data[email]': {
                required: true,
                email: true,
            },
            'data[password]': {
                required: true,
                minlength: 6,
            },
            'data[password_confirm]': {
                required: true,
                minlength: 6,
            }
        },
        focusCleanup: true,
        focusInvalid: false,
    })

})
